import { render, staticRenderFns } from "./TheUpsertCommission.vue?vue&type=template&id=8c0a1fb2"
import script from "./TheUpsertCommission.vue?vue&type=script&lang=ts"
export * from "./TheUpsertCommission.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports